module.exports = __webpack_public_path__ + "static/media/sport.25754145.mp3";